/**
 * Overwritten by scripts/inject-supabase-env.js in CI before bundle.
 * Do not commit non-empty literals (same sensitivity as env secrets).
 */
export const SUPABASE_URL = "https://lbehfgzitmcaeygnpeie.supabase.co"
export const SUPABASE_ANON_KEY = "sb_publishable_V9NIzbz-k8GySIJwnThp8A_na03p7I5"
